import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    loadingPropCheck,
    renderChild,
} from './utils';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Button.scss';

const propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    loading: loadingPropCheck,
    // eslint-disable-next-line react-redux/no-unused-prop-types
    loadingAnimation: PropTypes.oneOf(['spin', 'dots']),
    onClick: PropTypes.func,
    outline: PropTypes.bool,
    success: PropTypes.bool,
    type: PropTypes.string,
    unstyled: PropTypes.bool,
};

function Button(props) {
    const {
        className,
        disabled = false,
        label,
        loading = false,
        onClick = () => undefined,
        outline = false,
        success = false,
        type = 'submit',
        unstyled = false,
        id,
    } = props;

    return (
        <button
            aria-label={label}
            className={classNames(
                className,
                styles.button,
                { [styles.styledButton]: !unstyled },
                { [styles.success]: success && !loading },
                { [styles.outline]: outline },
            )}
            disabled={disabled}
            id={id}
            onClick={onClick}
            type={type}
        >
            {renderChild(props)}
        </button>
    );
}

Button.propTypes = propTypes;

export default Button;
